import styled from "styled-components";

interface HeaderProps {
  isHome?: boolean;
  position?: "relative" | "";
}

export const HeaderWrapper = styled.div<HeaderProps>`
  position: ${(props) => (props.position)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background: #eceef0;
  color: #fff;
  z-index: 99;
  height: 53px;
  box-shadow: 0px 1px 2px #2c2c2c;
  border-top: 8px solid #77EC84;
  @media (max-width: 768px) {
    height: ${(props) => (props.isHome ? "53px" : "73px")};
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding-right: 10px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding-right: 0px;
  }
`;

interface StepContainerProps {
  visible?: boolean;
}

export const StepContainer = styled.div<StepContainerProps>`
  color: #000;
  display: ${(props) => (props.visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  margin: 12px 12px 5px 12px;
  width: 100%;
  gap: 4px;
  hr {
    width: 60px;
    height: 1px;
  }
  p {
    font-size: 12px;
    width: min-content;
    text-align: center;
    color: #2c2c2c;
  }
  @media (max-width: 768px) {
    margin: 5px 0px;
    hr {
    width: 30px;
    height: 1px;
  }
  }
  @media (min-width: 909px) {
    p {
      width: auto;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`

interface StepNumberProps {
  status?: "passed" | "current" | "pending";
}

export const StepNumber = styled.span<StepNumberProps>`
  background-color: ${(props) =>
    props.status === "passed" ? "#77EC84" :
      props.status === "current" ? "#355B94" : "#aaa"};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  width: 16px;
  height: 16px;
  hr {
    width: 60px;
    height: 1px;
  }
`;
interface ButtonContainerProps {
  showButton?: boolean;
}
export const ButtonContainer = styled.div<ButtonContainerProps>`
display:${(props) => !props.showButton ? "none" : "flex"};
display: flex;
align-items: center;
justify-content: end;
@media (max-width: 768px) {
  display: none;
}
`

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  cursor?: string;
  isFilled?: boolean;
  showButton?: boolean;
  color?: string;
}
export const ButtonMobile = styled.button<ButtonProps>`
  display:${(props) => !props.showButton ? "none" : "flex"};
  align-items: center;
  justify-content: center;
  font-size: 12px;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  cursor: ${(props) => props.cursor || "pointer"};
  pointer-events: ${(props) => !props.isFilled && "none"};
  border: none;
  border-radius: 99px;
  width: fit-content;
  height: 30px;
  padding: 0 8px;
  font-family: "Archivo-Regular";
  color: ${(props) => props.color || "#fff"};
  text-transform: uppercase;

  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
  a {
    text-decoration: none;
    color: #fff;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;



